import React, {useState, useEffect}  from 'react'
import {reqCabinetTypes,} from "../api";
export default function CabinetType(props) {
    const [cabinetTypes, setCabinetTypes] = useState({});
    useEffect(() => {
        getCabinetTypes();
    }, []);
    const getCabinetTypes = async () => {
        const result = await reqCabinetTypes();
        if (result.code === 200) {
            const data = {};
            result.data.forEach(o => {
                data[o.cabinetType] = o.cabinetTypeName;
            });
            setCabinetTypes(data);
        }
    };
    return <span>{cabinetTypes[props.value]}</span>
}


